<template>
  <AlterStatusCourseModal
    v-if="showAlterStatusCourseModal"
    :courseId="courseId"
    @closeModal="closeCreateEditAlterStatusCourseModal"
  />
  <CreateEditCourseModal
    v-if="showCreateEditCourseModal"
    :courseId="courseId"
    @closeModal="closeCreateEditAlterStatusCourseModal"
  />
  <LoadingData v-if="loadData" />
  <div v-else class="card">
    <div class="card-header d-flex align-items-center py-0">
      <h6 class="py-3 mb-0">Detalhes do Curso</h6>
      <div class="ms-auto">
        <router-link
          to="/courses"
          class="btn btn-outline-dark"
          title="Listagem de Cursos"
        >
          Listagem de Cursos
        </router-link>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <p><strong>Nome:</strong> {{ course.name }}</p>
        </div>
        <div class="col-md-12 col-sm-12">
          <p><strong>Descrição:</strong> {{ course.description }}</p>
        </div>
        <div class="col-md-4 col-sm-12">
          <p>
            <strong>Aproveitamento Mínimo:</strong>
            {{ course.minimumGrade }}%
          </p>
        </div>
        <div class="col-md-4 col-sm-12">
          <p>
            <strong>Instrutor: </strong>
            {{ course.instructor }}
          </p>
        </div>
        <div class="col-md-4 col-sm-12">
          <p>
            <strong>Status: </strong>
            <span v-html="statusTranslate(course.status)" />
          </p>
        </div>
      </div>
    </div>
    <div class="card-footer d-flex justify-content-between align-items-center">
      <ul class="list-inline text-muted mb-0">
        <li class="list-inline-item">
          Cadastro por:
          {{ createdUpdatedUser(course.createdBy, course.createdAt) }}
        </li>
        <li class="list-inline-item">
          Atualizado por:
          {{ createdUpdatedUser(course.updatedBy, course.updatedAt) }}
        </li>
      </ul>
      <div class="w-50 text-end">
        <button
          type="button"
          class="btn btn-teal"
          title="Alterar Status"
          @click="showAlterStatusCourseModal = true"
        >
          Alterar Status
        </button>
        <button
          type="button"
          class="btn btn-warning ms-2"
          title="Editar Curso"
          @click="showCreateEditCourseModal = true"
        >
          Editar Curso
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import AlterStatusCourseModal from '@/components/courses/courses/AlterStatusCourseModal.vue'
import CreateEditCourseModal from '@/components/courses/courses/CreateEditCourseModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import { createdUpdatedUser, statusTranslate } from '@/utils/strings'

export default {
  name: 'DetailsCourseWithEdit',

  components: {
    AlterStatusCourseModal,
    CreateEditCourseModal,
    LoadingData,
  },

  props: {
    courseId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loadData: true,
      showAlterStatusCourseModal: false,
      showCreateEditCourseModal: false,
      course: {},
      createdUpdatedUser,
      statusTranslate,
    }
  },

  methods: {
    async getCourse() {
      try {
        this.course = await this.$store.dispatch('getCourse', this.courseId)
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    closeCreateEditAlterStatusCourseModal(loadCourse) {
      if (loadCourse) {
        this.getCourse()
      }
      this.showAlterStatusCourseModal = false
      this.showCreateEditCourseModal = false
    },
  },

  mounted() {
    this.getCourse()
  },
}
</script>
